import React , {  useState, createContext , useEffect } from 'react';
import { getDocs , collection , db  } from '../firebase';


export const AppContext = createContext();

export const AppProvider = (props) => {

  const [ hasCompleted , setHasCompleted ] = useState(false);
  const [ emailFirst , setEmailFirst ] = useState('');

    return (
            <AppContext.Provider value={ { 
              completed: [hasCompleted , setHasCompleted],
              emailFirst: [emailFirst , setEmailFirst]
              
               }} >
                {props.children}
            </AppContext.Provider>
    )
}